import React from 'react';
import { useIntl } from 'react-intl';
import { FormControl, FormLabel, Select, MenuItem, FormHelperText } from '@mui/material';

const MultiDropdownField = ({ input, meta, label, dropdowns, layout = { gap: 8 }, readOnly }) => {
  const intl = useIntl();
  const value = input.value || {};

  const handleChange = (name, newValue) => {
    if (!readOnly) {
      const updatedValue = { ...value, [name]: newValue };
      input.onChange(updatedValue);
    }
  };

  return (
    <div style={{ marginBottom: 16 }}>
      {label && <FormLabel style={{ fontWeight: 600, marginBottom: 8, display: 'block' }}>{label}</FormLabel>}
      <div style={{ display: 'flex', gap: layout.gap || 8 }}>
        {dropdowns.map(dd => (
          <FormControl key={dd.name} style={{ minWidth: 80 }} disabled={readOnly}>
            <Select
              value={value[dd.name] ?? ''} 
              onChange={e => handleChange(dd.name, e.target.value)}
              variant="outlined"
              size="small"
              readOnly={readOnly}
            >
              {dd.options.map(opt => (
                <MenuItem key={opt.value} value={opt.value}>
                  {(!isNaN(opt.label) || typeof opt.label === 'number')
                    ? opt.label
                    : (typeof opt.label === 'string' && opt.label.startsWith('ApplicationForm.'))
                      ? intl.formatMessage({ id: opt.label })
                      : opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ))}
      </div>
      {meta.touched && meta.error && <FormHelperText error>{meta.error}</FormHelperText>}
    </div>
  );
};

export default MultiDropdownField;